/**
 * Headcounts from `Workforce` on the application. The API records them split by
 * origin *and* by tenure (local/foreign × permanent/temporary), so each figure
 * below is a sum of the two matching fields rather than a single one.
 */
interface IProps {
    localEmployees?: number;
    foreignEmployees?: number;
    permanentEmployees?: number;
    temporaryEmployees?: number;
}

function CountCell({ label, value }: { label: string; value?: number }) {
    if (value === undefined || value === null) return null;
    return (
        <div>
            <span className="text-gray-500 text-sm">{label}</span>
            <p className="text-lg font-medium text-gray-900">{value}</p>
        </div>
    );
}

export default function WorkforceDetails({
    localEmployees,
    foreignEmployees,
    permanentEmployees,
    temporaryEmployees
}: IProps) {
    const hasCounts = [localEmployees, foreignEmployees, permanentEmployees, temporaryEmployees]
        .some((value) => value !== undefined && value !== null);

    return (
        <div>
            <h1 className="my-2 text-lg font-semibold text-[#3C1E03]">Workforce Details</h1>
            {hasCounts ? (
                <div className="grid grid-cols-2 gap-x-8 gap-y-6 bg-white shadow-sm rounded-2xl p-4">
                    <CountCell label="Local employees" value={localEmployees} />
                    <CountCell label="Foreign employees" value={foreignEmployees} />
                    <CountCell label="Permanent employees" value={permanentEmployees} />
                    <CountCell label="Temporary employees" value={temporaryEmployees} />
                </div>
            ) : (
                <div className="bg-white shadow-sm rounded-2xl p-4">
                    <p className="text-sm text-gray-500">
                        No workforce details recorded for this application.
                    </p>
                </div>
            )}
        </div>
    );
}
